export default __webpack_public_path__ + "static/media/godex_g500.fb130e9f.png";